<template>
  <div class="modal standard-scheme" @click.self="cancel">
    <div class="modal-container">
      <header>
        <span v-t>Contributors</span> <span v-if="totalContributors > 0"> ({{ totalContributors }}) </span>
      </header>
      <div class="list modal-list two-line-dense-list">
        <a
          v-for="contributor in registeredContributors"
          :key="contributor.id"
          class="list-item is-actionable"
          :href="'/' + contributor.username"
          target="_blank"
        >
          <div class="list-item-primary">
            <avatar-image :user="contributor" :width="36" :height="36" />
            <div>
              <div>{{ contributor.name || contributor.username }}</div>
              <div class="caption-type">{{ contributor.username }}</div>
            </div>
          </div>
        </a>
        <div v-if="anonymousContributors.length > 0" class="list-item">
          <div class="list-item-primary">
            <avatar-image :width="36" :height="36" />
            <div>
              <div class="muted-type" v-t>Anonymous contributors</div>
              <div class="muted-type">{{ anonymousContributors.length }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import t from 'vuedirectives/t'
import AvatarImage from 'vuecomponents/avatar_image'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import { fetchJson } from '@padlet/fetch'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { AvatarImage },
  directives: { t },
  mixins: [EscapeToCancelMixin],
  data() {
    return {
      registeredContributors: [],
      anonymousContributors: [],
    }
  },
  computed: {
    ...mapGetters(['wallId', 'builder']),
    totalContributors() {
      return this.registeredContributors.length + this.anonymousContributors.length
    },
  },
  mounted() {
    // TODO: Escape key
    fetchJson(`/walls/${this.wallId}/contributors`).then(data => {
      const unsortedRegisteredContributors = data.filter(x => !!x.username)
      this.registeredContributors = unsortedRegisteredContributors.sort(x =>
        this.builder.id === x.id ? '' : x.short_name,
      )
      this.anonymousContributors = data.filter(x => !x.username)
    })
  },
  methods: {
    ...mapActions({
      cancel: 'hideContributorsList',
    }),
  },
}
</script>
